import palette from '@lib/core/src/theme/palette';
import { Popper as MuiPopper, IconButton, Stack, styled, Typography, Paper } from '@mui/material';

import { BORDER } from '@/pages/HomePage/HomeStyles';

export const CheckListContainer = styled(Stack)({
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '16px',
  background: palette.white,
  border: BORDER,
  borderRadius: '12px'
});

export const CheckListItemsContainer = styled(Stack)({
  width: '100%'
});

export const Popper = styled(MuiPopper)({
  zIndex: 1300,
  inset: 'unset !important',
  top: '80px !important',
  left: '77px !important',
  transform: 'unset !important'
});

export const CheckListPaper = styled(Paper)({
  borderRadius: '12px',
  width: 400,
  maxHeight: '77vh',
  margin: '32px',
  overflow: 'auto'
});

export const ItemContainer = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  borderBottom: `1px solid ${palette.grey[1200]}`,
  padding: '12px',
  gap: '8px'
});

export const Header = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '16px 16px 0 16px'
});

export const CloseButton = styled(IconButton)({});

export const ItemTitle = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isCompleted'
})<{ isCompleted: boolean }>(({ isCompleted }) => ({
  fontWeight: 500,
  color: isCompleted ? palette.grey[400] : palette.black,
  fontSize: '12px',
  textDecoration: isCompleted ? 'line-through' : 'none'
}));

export const Wrapper = styled(Stack)({
  position: 'absolute',
  top: '20px',
  left: '20px',
  zIndex: 1000
});

export const Doughnut = styled(Stack)({
  height: '52px',
  width: '52px',
  borderRadius: '50%',
  background: 'transparent',
  border: `4px solid ${palette.grey[200]}`,
  boxShadow: '0 2px 8px 0 rgba(24, 39, 75, 0.08)',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
});
